export default "__VITE_ASSET__DhlJ5mqg__"